import { render, staticRenderFns } from "./TeamDetail.vue?vue&type=template&id=302c12ea&"
import script from "./TeamDetail.vue?vue&type=script&lang=js&"
export * from "./TeamDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports